<template>
  <div class="question-analysis">
    <div class="chart-row" v-show="!onlyTagCharts">
      <el-card class="chart-card half-width" ref="difficultyCard">
        <div slot="header" class="card-header">
          <span>题目难度分布</span>
          <div class="operations">
            <el-tooltip content="导出图片" placement="top">
              <el-button type="text" icon="el-icon-download" @click="handleExportDifficulty" />
            </el-tooltip>
            <el-tooltip content="放大显示" placement="top">
              <el-button type="text" icon="el-icon-full-screen" @click="handleFullscreenDifficulty" />
            </el-tooltip>
          </div>
        </div>
        <div class="chart-container" ref="difficultyChart"></div>
      </el-card>

      <el-card class="chart-card half-width" ref="errorTypeCard">
        <div slot="header" class="card-header">
          <span>题目错误分布</span>
          <div class="operations">
            <!-- 时间选择器 -->
            <div class="filter-item">
              <el-date-picker
                v-model="errorTypeDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :clearable="true"
                :picker-options="pickerOptions"
                @change="handleErrorTypeDateChange"
              />
            </div>
            
            <div class="button-group">
              <el-tooltip content="重置时间筛选" placement="top">
                <el-button type="text" icon="el-icon-refresh" @click="handleErrorTypeReset" />
              </el-tooltip>
              <el-tooltip content="导出图片" placement="top">
                <el-button type="text" icon="el-icon-download" @click="handleExportErrorType" />
              </el-tooltip>
              <el-tooltip content="放大显示" placement="top">
                <el-button type="text" icon="el-icon-full-screen" @click="handleFullscreenErrorType" />
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="chart-container" ref="errorTypeChart"></div>
      </el-card>
    </div>

    <div class="chart-row" v-show="!onlyTagCharts">
      <div class="chart-card full-width">
        <question-wrong-trend ref="wrongTrendChart" />
      </div>
    </div>

    <div class="chart-row" v-show="!onlyTagCharts">
      <div class="chart-card full-width">
        <question-difficulty-trend ref="difficultyTrendChart" />
      </div>
    </div>

    <div class="chart-row" v-show="!onlyTagCharts">
      <el-card class="chart-card half-width" ref="originalScoreDifficultyCard">
        <div slot="header" class="card-header">
          <span>原始分与难度关系</span>
          <div class="operations">
            <el-tooltip content="导出图片" placement="top">
              <el-button type="text" icon="el-icon-download" @click="handleExportOriginalScoreDifficulty" />
            </el-tooltip>
            <el-tooltip content="放大显示" placement="top">
              <el-button type="text" icon="el-icon-full-screen" @click="handleFullscreenOriginalScoreDifficulty" />
            </el-tooltip>
          </div>
        </div>
        <div class="chart-container" ref="originalScoreDifficultyChart"></div>
      </el-card>

      <el-card class="chart-card half-width" ref="fixedScoreDifficultyCard">
        <div slot="header" class="card-header">
          <span>订正分与难度关系</span>
          <div class="operations">
            <el-tooltip content="导出图片" placement="top">
              <el-button type="text" icon="el-icon-download" @click="handleExportFixedScoreDifficulty" />
            </el-tooltip>
            <el-tooltip content="放大显示" placement="top">
              <el-button type="text" icon="el-icon-full-screen" @click="handleFullscreenFixedScoreDifficulty" />
            </el-tooltip>
          </div>
        </div>
        <div class="chart-container" ref="fixedScoreDifficultyChart"></div>
      </el-card>
    </div>

    <div class="chart-row" v-show="showTagCharts || onlyTagCharts">
      <el-card class="chart-card full-width" ref="tagCloudCard">
        <div slot="header" class="card-header">
          <span>标签热度图</span>
          <div class="operations">
            <el-tooltip content="导出图片" placement="top">
              <el-button type="text" icon="el-icon-download" @click="handleExportTagCloud" />
            </el-tooltip>
            <el-tooltip content="放大显示" placement="top">
              <el-button type="text" icon="el-icon-full-screen" @click="handleFullscreenTagCloud" />
            </el-tooltip>
          </div>
        </div>
        <div class="chart-container" ref="tagCloudChart"></div>
      </el-card>
    </div>

    <div class="chart-row" v-show="showTagCharts || onlyTagCharts">
      <el-card class="chart-card full-width score-tag-chart" ref="scoreTagCard">
        <div slot="header" class="card-header">
          <span>标签分布图</span>
          <div class="operations">
            <el-tooltip content="导出图片" placement="top">
              <el-button type="text" icon="el-icon-download" @click="handleExportScoreTag" />
            </el-tooltip>
            <el-tooltip content="放大显示" placement="top">
              <el-button type="text" icon="el-icon-full-screen" @click="handleFullscreenScoreTag" />
            </el-tooltip>
          </div>
        </div>
        <div class="chart-container" ref="scoreTagChart"></div>
      </el-card>
    </div>

    <!-- 全屏弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="90%"
      :destroy-on-close="false"
      :show-close="false"
      class="chart-dialog vertical-center-dialog"
      @closed="handleDialogClosed"
      @open="handleDialogOpen"
      @close="handleDialogClose"
    >
      <div slot="title" class="dialog-header">
        <span>{{ dialogTitle }}</span>
        <div class="dialog-operations">
          <el-tooltip content="导出图片" placement="top">
            <el-button type="text" icon="el-icon-download" @click="handleExportFullscreen" />
          </el-tooltip>
          <el-tooltip content="关闭" placement="top">
            <el-button type="text" icon="el-icon-close" @click="closeDialog" />
          </el-tooltip>
        </div>
      </div>
      <div class="fullscreen-chart" ref="fullscreenChart"></div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-wordcloud'
import request from '@/utils/request'
import html2canvas from 'html2canvas'
import _ from 'lodash'
import QuestionDifficultyTrend from './QuestionDifficultyTrend.vue'
import QuestionMasteryTrend from './QuestionMasteryTrend.vue'
import QuestionWrongTrend from './QuestionWrongTrend.vue'
import { getErrorTagInlineStyle } from '@/constants/errorTypes'

export default {
  name: 'QuestionAnalysis',
  components: {
    QuestionDifficultyTrend,
    QuestionMasteryTrend,
    QuestionWrongTrend
  },
  props: {
    showTagCharts: {
      type: Boolean,
      default: true
    },
    onlyTagCharts: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      difficultyChart: null,
      errorTypeChart: null,
      originalScoreDifficultyChart: null,
      fixedScoreDifficultyChart: null,
      tagCloudChart: null,
      scoreTagChart: null,
      chartData: {
        difficulties: [],
        errorTypeDistribution: [],
        scoreDifficulty: [],
        tags: [],
        scoreTags: [],
        tagDifficulty: [],
        questionScores: []
      },
      difficultyOrder: ['未分类', '红题', '橙题', '黄题', '绿题', '蓝题', '紫题', '黑题'],
      fullscreenChart: null,
      dialogVisible: false,
      dialogTitle: '',
      currentChartType: '',
      resizeHandler: null,
      isInitializing: false,
      errorTypeDateRange: null,
      pickerOptions: {
        shortcuts: [
          {
            text: '重置',
            onClick(picker) {
              picker.$emit('pick', null)
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.initCharts()
    this.fetchData()
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy() {
    this.cleanupCharts()
    window.removeEventListener('resize', this.resizeCharts)
  },
  computed: {
    sortedTags() {
      // 合并所有标签数据源并去重排序
      const allTags = new Set([
        ...this.chartData.scoreTags.map(item => item.tag),
        ...this.chartData.tagDifficulty.map(item => item.tag)
      ])
      return [...allTags].sort()
    }
  },
  methods: {
    forceResizeAll() {
      try {
        this.$refs.difficultyTrendChart?.forceResize && this.$refs.difficultyTrendChart.forceResize()
      } catch (e) {}
      this.difficultyChart?.resize()
      this.errorTypeChart?.resize()
      this.originalScoreDifficultyChart?.resize()
      this.fixedScoreDifficultyChart?.resize()
      this.tagCloudChart?.resize()
      this.scoreTagChart?.resize()
    },
    initCharts() {
      this.difficultyChart = echarts.init(this.$refs.difficultyChart)
      this.errorTypeChart = echarts.init(this.$refs.errorTypeChart)
      this.originalScoreDifficultyChart = echarts.init(this.$refs.originalScoreDifficultyChart)
      this.fixedScoreDifficultyChart = echarts.init(this.$refs.fixedScoreDifficultyChart)
      this.tagCloudChart = echarts.init(this.$refs.tagCloudChart)
      this.scoreTagChart = echarts.init(this.$refs.scoreTagChart)
    },
    resizeCharts() {
      this.difficultyChart?.resize()
      this.errorTypeChart?.resize()
      this.originalScoreDifficultyChart?.resize()
      this.fixedScoreDifficultyChart?.resize()
      this.tagCloudChart?.resize()
      this.scoreTagChart?.resize()
    },
    async fetchData() {
      try {
        // 构建错误类型分布的请求参数
        const errorTypeParams = {}
        if (this.errorTypeDateRange && this.errorTypeDateRange.length === 2) {
          errorTypeParams.start_date = this.errorTypeDateRange[0]
          errorTypeParams.end_date = this.errorTypeDateRange[1]
        }

        const [difficultyRes, errorTypeRes, scoreDifficultyRes, tagsRes, scoreTagsRes, tagDifficultyRes, questionScoresRes] = await Promise.all([
          request.get('/api/analysis/question/difficulty'),
          request.get('/api/analysis/question/error_type_distribution', { params: errorTypeParams }),
          request.get('/api/analysis/question/score_difficulty'),
          request.get('/api/analysis/question/tags'),
          request.get('/api/analysis/question/score_tags'),
          request.get('/api/analysis/question/tag_difficulty'),
          request.get('/api/analysis/question/question_scores')
        ])

        // 检查响应数据
        if (!difficultyRes.data || !difficultyRes.data.difficulties) {
          throw new Error('难度分布数据格式错误')
        }
        if (!errorTypeRes.data || !errorTypeRes.data.data) {
          throw new Error('错误类型分布数据格式错误')
        }
        if (!scoreDifficultyRes.data || !scoreDifficultyRes.data.data) {
          throw new Error('得分难度数据格式错误')
        }
        if (!tagsRes.data || !tagsRes.data.tags) {
          throw new Error('标签数据格式错误')
        }
        if (!scoreTagsRes.data || !scoreTagsRes.data.data) {
          throw new Error('得分标签数据格式错误')
        }
        if (!tagDifficultyRes.data || !tagDifficultyRes.data.data) {
          throw new Error('标签难度数据格式错误')
        }
        if (!questionScoresRes.data || !questionScoresRes.data.data) {
          throw new Error('题目得分数据格式错误')
        }

        this.chartData = {
          difficulties: difficultyRes.data.difficulties || [],
          errorTypeDistribution: errorTypeRes.data.data || [],
          scoreDifficulty: scoreDifficultyRes.data.data || [],
          tags: tagsRes.data.tags || [],
          scoreTags: scoreTagsRes.data.data || [],
          tagDifficulty: tagDifficultyRes.data.data || [],
          questionScores: questionScoresRes.data.data || []
        }

        this.updateCharts()
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error(error.message || '获取数据失败')
      }
    },
    getRandomColor() {
      const colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272']
      return colors[Math.floor(Math.random() * colors.length)]
    },
    updateCharts() {
      // 题目难度分布图
      const sortedDifficulties = this.difficultyOrder.map(difficulty => {
        return this.chartData.difficulties.find(item => item.name === difficulty) || {
          name: difficulty,
          value: 0
        }
      })

      // 错误类型分布（单层：每类仅一段，值为总数）
      const errorData = this.chartData.errorTypeDistribution
      const pieData = []
      errorData.forEach(item => {
        const name = item.error_name || '未定义'
        const total = item.total || 0
        if (total > 0) {
          const color = item.error_code ? (getErrorTagInlineStyle(item.error_code)?.backgroundColor || '#1E90FF') : '#E0E0E0'
          pieData.push({ name, value: total, itemStyle: { color, borderColor: '#fff', borderWidth: 2 } })
        }
      })

      // 标签词云图
      const tagCloudOption = {
        backgroundColor: '#ffffff',
        series: [{
          type: 'wordCloud',
          shape: 'circle',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          sizeRange: [12, 48],
          rotationRange: [-90, 90],
          rotationStep: 45,
          gridSize: 10,
          drawOutOfBound: false,
          textStyle: {
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
            color: function () {
              return 'rgb(' + [
                Math.round(Math.random() * 160),
                Math.round(Math.random() * 160),
                Math.round(Math.random() * 160)
              ].join(',') + ')'
            }
          },
          emphasis: {
            focus: 'self',
            textStyle: {
              shadowBlur: 10,
              shadowColor: '#333'
            }
          },
          data: this.chartData.tags.map(tag => ({
            name: tag.name,
            value: tag.value,
            textStyle: {
              color: this.getRandomColor()
            }
          }))
        }]
      }

      // 原始分与难度关系图
      const originalScoreDifficultyOption = {
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: function(params) {
            // 确保有data属性且索引存在
            if (!params.data || params.data.length < 3) return '';
            
            const origIndex = params.data[2];
            // 确保索引在有效范围内
            if (origIndex < 0 || origIndex >= this.chartData.scoreDifficulty.length) return '';
            
            const rawData = this.chartData.scoreDifficulty[origIndex];
            if (!rawData) return '';
            if (rawData.original_count === 0) return ''; // 数据为0时不显示tooltip
            
            const difficulty = rawData.difficulty || '未分类'
            return `
              <div style="padding: 4px;">
                <div style="font-weight: bold; margin-bottom: 6px;">${difficulty}</div>
                <div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.3);">
                  <div>分数区间：${rawData.score_range}</div>
                  <div>原始分题目数量：${rawData.original_count}</div>
                </div>
              </div>
            `
          }.bind(this),
          position: 'top'
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '8%',
          top: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.difficultyOrder,
          boundaryGap: true,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '分数',
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: function(value) {
              if (value === 100) return '100分';
              if (value >= 76) return '76-99分';
              if (value >= 51) return '51-75分';
              if (value >= 26) return '26-50分';
              if (value >= 1) return '1-25分';
              return '0分';
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          {
          type: 'scatter',
            symbolSize: function (data) {
              const item = this.chartData.scoreDifficulty[data[2]];
              if (!item) return 0;
              if (item.original_count === 0) return 0; // 过滤掉count为0的数据点
              return Math.max(5, Math.min(80, Math.sqrt(item.original_count) * 8));
            }.bind(this),
          itemStyle: {
              color: '#409EFF',  // 使用 Element UI 的主要蓝色
              opacity: 0.7
            },
            data: this.chartData.scoreDifficulty.filter(item => item.original_count > 0).map((item, index) => [
              this.difficultyOrder.indexOf(item.difficulty || '未分类'),
              item.y_value,
              this.chartData.scoreDifficulty.indexOf(item) // 保持原始索引引用
            ])
          }
        ]
      }

      // 订正分与难度关系图
      const fixedScoreDifficultyOption = {
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: function(params) {
            // 确保有data属性且索引存在
            if (!params.data || params.data.length < 3) return '';
            
            const origIndex = params.data[2];
            // 确保索引在有效范围内
            if (origIndex < 0 || origIndex >= this.chartData.scoreDifficulty.length) return '';
            
            const rawData = this.chartData.scoreDifficulty[origIndex];
            if (!rawData) return '';
            if (rawData.fixed_count === 0) return ''; // 数据为0时不显示tooltip
            
            const difficulty = rawData.difficulty || '未分类'
            return `
              <div style="padding: 4px;">
                <div style="font-weight: bold; margin-bottom: 6px;">${difficulty}</div>
                <div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.3);">
                  <div>分数区间：${rawData.score_range}</div>
                  <div>订正分题目数量：${rawData.fixed_count}</div>
                </div>
              </div>
            `
          }.bind(this),
          position: 'top'
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '8%',
          top: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.difficultyOrder,
          boundaryGap: true,
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: '分数',
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: function(value) {
              if (value === 100) return '100分';
              if (value >= 76) return '76-99分';
              if (value >= 51) return '51-75分';
              if (value >= 26) return '26-50分';
              if (value >= 1) return '1-25分';
              return '0分';
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'scatter',
            symbolSize: function (data) {
              const item = this.chartData.scoreDifficulty[data[2]];
              if (!item || item.fixed_count === 0) return 0;
              return Math.max(5, Math.min(80, Math.sqrt(item.fixed_count) * 8));
            }.bind(this),
            itemStyle: {
              color: '#67C23A',  // 使用 Element UI 的成功绿色
              opacity: 0.7
            },
            data: this.chartData.scoreDifficulty.filter(item => item.fixed_count > 0).map((item, index) => [
              this.difficultyOrder.indexOf(item.difficulty || '未分类'),
              item.y_value,
              this.chartData.scoreDifficulty.indexOf(item) // 保持原始索引引用
            ])
          }
        ]
      }

      // 标签分布图
      const scoreTagOption = {
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: function(params) {
            const data = params.data
            if (!data) return ''
            const tag = data.tag || ''
            if (params.seriesName === '平均分') {
              return `
                <div style="padding: 4px;">
                  <div style="font-weight: bold; margin-bottom: 6px;">${tag}</div>
                  <div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.3);">
                    <div>平均分：${data.score.toFixed(1)}</div>
                    <div>题目数：${data.count}</div>
                  </div>
                </div>
              `
            } else if (params.seriesName === '难度') {
              // 根据新的难度值计算方式获取难度名称
              let difficultyName = '';
              if (data.difficulty === 0) {
                difficultyName = '未分类';
              } else if (data.difficulty === 100) {
                difficultyName = '黑题';
              } else {
                const step = 100 / 7; // 7个间隔对应8个难度等级
                const index = Math.floor(data.difficulty / step);
                difficultyName = this.difficultyOrder[index] || '未分类';
              }
              return `
                <div style="padding: 4px;">
                  <div style="font-weight: bold; margin-bottom: 6px;">${tag}</div>
                  <div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.3);">
                    <div>平均难度：${difficultyName}</div>
                    <div>题目数：${data.count}</div>
                  </div>
                </div>
              `
            } else {
              return `
                <div style="padding: 4px;">
                  <div style="font-weight: bold; margin-bottom: 6px;">${tag}</div>
                  <div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.3);">
                    <div>题目名称：${data.question_name || ''}</div>
                    <div>得分：${data.score.toFixed(1)}</div>
                  </div>
                </div>
              `
            }
          }.bind(this)
        },
        legend: {
          data: ['得分', '平均分', '难度'],
          bottom: 0,
          left: 'center',
          padding: [0, 0, 0, 0]
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '5%',
          top: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.sortedTags,
          axisLabel: {
            rotate: 45,
            interval: 0,
            fontSize: 12,
            align: 'right',
            verticalAlign: 'middle',
            margin: 0
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '平均分/得分',
            min: 0,
            max: 100,
            interval: 20,
            minInterval: 20,
            splitNumber: 5,
            nameTextStyle: {
              padding: [0, 0, 0, 30]
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          {
            type: 'value',
            name: '难度',
            min: 0,
            max: 100,
            interval: 14.29, // 100/7，确保显示所有8个难度等级
            position: 'right',
            axisLabel: {
              formatter: (value) => {
                // 确保全屏模式下使用相同的难度刻度设置
                if (value === 0) return '未分类';
                if (value === 100) return '黑题';
                
                // 将1-99的范围平均分配给中间6个难度等级
                const step = 100 / 7; // 7个间隔对应8个难度等级
                const index = Math.floor(value / step);
                if (index >= 0 && index < this.difficultyOrder.length - 1) {
                  return this.difficultyOrder[index];
                }
                return '';
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '得分',
            type: 'scatter',
            yAxisIndex: 0,
            data: this.chartData.questionScores.map(item => ({
              value: [
                this.sortedTags.indexOf(item.tag),
                item.score
              ],
              tag: item.tag,
              question_name: item.question_name,
              score: item.score,
              symbolSize: 10  // 固定大小，因为每个点代表一道题
            })),
            itemStyle: {
              color: '#B37FEB',  // 使用紫色
              opacity: 0.7  // 设置不透明度为1，去掉透明效果
            }
          },
          {
            name: '平均分',
            type: 'scatter',
            yAxisIndex: 0,
            data: this.chartData.scoreTags.map(item => ({
              value: [
                this.sortedTags.indexOf(item.tag),
                item.score
              ],
              tag: item.tag,
              score: item.score,
              count: item.count,
              symbolSize: Math.max(1, Math.min(50, Math.sqrt(item.count) * 10))
            })),
            itemStyle: {
              color: '#409EFF',
              opacity: 0.7
            }
          },
          {
            name: '难度',
            type: 'scatter',
            yAxisIndex: 1,
            data: this.chartData.tagDifficulty.map(item => {
              // 新的难度映射逻辑
              const difficultyIndex = this.difficultyOrder.indexOf(item.difficulty || '未分类');
              // 将难度索引映射到0-100范围
              // 0对应"未分类"(索引0)，100对应"黑题"(索引7)
              let avgDifficulty = 0;
              if (difficultyIndex === 0) {
                avgDifficulty = 0; // 未分类
              } else if (difficultyIndex === 7) {
                avgDifficulty = 100; // 黑题
              } else {
                // 中间6个难度等级平均分配在1-99范围内
                const step = 100 / 7; // 7个间隔对应8个难度等级
                avgDifficulty = difficultyIndex * step;
              }
              
              return {
                value: [
                  this.sortedTags.indexOf(item.tag),
                  avgDifficulty
                ],
                tag: item.tag,
                difficulty: avgDifficulty,
                count: item.count,
                symbolSize: Math.max(1, Math.min(50, Math.sqrt(item.count) * 10))
              }
            }),
            itemStyle: {
              color: '#67C23A',
              opacity: 0.7
            }
          }
        ]
      }

      this.difficultyChart.setOption({
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: function(params) {
            if (!params || !params.data) return ''
            const name = params.name || ''
            const value = params.value || 0
            const percent = params.percent || 0
            
            // 获取难度标签样式
            const getDifficultyTagStyle = (difficulty) => {
              const index = this.difficultyOrder.indexOf(difficulty)
              if (index === -1) return null
              const colors = [
                '#D9D9D9',  // 未分类：灰色
                '#FFA39E',  // 红题：红色
                '#FFC069',  // 橙题：橙色
                '#FFF566',  // 黄题：黄色
                '#95DE64',  // 绿题：绿色
                '#69C0FF',  // 蓝题：蓝色
                '#B37FEB',  // 紫题：紫色
                '#595959'   // 黑题：黑色
              ]
              const color = colors[index] || colors[0]
              // 将颜色转换为 rgba 格式用于背景
              const hexToRgba = (hex, alpha) => {
                const r = parseInt(hex.slice(1, 3), 16)
                const g = parseInt(hex.slice(3, 5), 16)
                const b = parseInt(hex.slice(5, 7), 16)
                return `rgba(${r}, ${g}, ${b}, ${alpha})`
              }
              const bg = hexToRgba(color, 0.2)
              return `display: inline-block; padding: 0px 4px; margin-right: 4px; border-radius: 2px; font-size: 11px; background-color: ${bg}; border: 1px solid ${color}; color: ${color}; line-height: 1.2;`
            }
            
            const tagStyle = getDifficultyTagStyle(name)
            const titleHtml = tagStyle 
              ? `<span style="${tagStyle}">${name}</span>`
              : name
            
            return `
              <div style="padding: 4px;">
                <div style="font-weight: bold; margin-bottom: 6px;">${titleHtml}</div>
                <div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.3);">
                  <div>数量：${value}</div>
                  <div>占比：${percent.toFixed(1)}%</div>
                </div>
              </div>
            `
          }.bind(this)
        },
        legend: {
          type: 'plain',  // 使用普通图例
          orient: 'horizontal',
          bottom: '8%',
          left: 'center',
          itemGap: 12,  // 图例项之间的水平间距
          itemWidth: 20,  // 图例标记的宽度
          itemHeight: 10,  // 图例标记的高度
          textStyle: {
            fontSize: 12
          },
          data: this.difficultyOrder,
          formatter: function(name) {
            return name;
          },
          width: '90%',  // 增加宽度以容纳每行4个图例
          padding: [0, 0, 0, 0],
          align: 'auto',
          selectedMode: true,  // 启用图例点击
          pageIcons: false,  // 禁用翻页按钮
          inactiveColor: '#ccc',
          pageTextStyle: {
            color: 'transparent'  // 隐藏页码
          },
          pageButtonItemGap: 0,
          pageButtonGap: 0,
          pageButtonPosition: 'end',
          pageFormatter: '{current}/{total}',
          pageIconColor: 'transparent',
          pageIconInactiveColor: 'transparent',
          pageIconSize: 0,
          itemStyle: {
            borderWidth: 0  // 移除图例项的边框
          }
        },
        color: [
          '#D9D9D9',  // 未分类：灰色
          '#FFA39E',  // 红题：红色
          '#FFC069',  // 橙题：橙色
          '#FFF566',  // 黄题：黄色
          '#95DE64',  // 绿题：绿色
          '#69C0FF',  // 蓝题：蓝色
          '#B37FEB',  // 紫题：紫色
          '#595959'   // 黑题：黑色
        ],
        series: [{
          name: '题目难度',
          type: 'pie',
          radius: ['45%', '65%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: true,
          itemStyle: {
            borderRadius: 6,  // 设置扇形的圆角半径
            borderColor: '#fff',  // 设置边框颜色
            borderWidth: 2  // 设置边框宽度
          },
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '16',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: sortedDifficulties
        }]
      })

      this.errorTypeChart.setOption({
        backgroundColor: '#ffffff',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(50, 50, 50, 0.9)',
          borderColor: '#333',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: function(params) {
            const name = params.name || '未定义'
            const item = errorData.find(e => (e.error_name || '未定义') === name) || {}
            const total = item.total || 0
            const fixed = item.fixed || 0
            const unfixed = Math.max(0, total - fixed)
            const rate = total > 0 ? (fixed / total * 100).toFixed(2) : '0.00'
            
            // 计算该错误类型占总数的比例
            const totalAll = errorData.reduce((sum, e) => sum + (e.total || 0), 0)
            const totalRate = totalAll > 0 ? (total / totalAll * 100).toFixed(2) : '0.00'
            
            return `
              <div style="padding: 4px;">
                <div style="font-weight: bold; margin-bottom: 6px;">${name}</div>
                <div style="margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.3);">
                  <div>总数：${total}（${totalRate}%）</div>
                  <div>已订正：${fixed}</div>
                  <div>未订正：${unfixed}</div>
                  <div>订正率：${rate}%</div>
                </div>
              </div>
            `
          }
        },
        legend: {
          type: 'plain',
          orient: 'horizontal',
          bottom: '6%',
          left: 'center',
          itemGap: 12,
          itemWidth: 18,
          itemHeight: 8,
          textStyle: { fontSize: 12 },
          width: '90%',
          padding: [0, 0, 0, 0],
          align: 'auto',
          data: errorData.map(i => i.error_name || '未定义'),
          selectedMode: true  // 启用图例点击
        },
        series: [
          {
            type: 'pie',
            radius: ['45%', '65%'],
            center: ['50%', '38%'],
            label: { show: false },
            data: pieData,
            itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 }
          }
        ]
      })
      this.originalScoreDifficultyChart.setOption(originalScoreDifficultyOption)
      this.fixedScoreDifficultyChart.setOption(fixedScoreDifficultyOption)
      this.tagCloudChart.setOption(tagCloudOption)
      this.scoreTagChart.setOption(scoreTagOption)
    },
    handleExportErrorType() {
      const dataURL = this.errorTypeChart.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#fff' })
      const link = document.createElement('a')
      link.download = '题目错误分布.png'
      link.href = dataURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleFullscreenErrorType() {
      this.cleanupFullscreen()
      this.currentChartType = 'errorType'
      this.dialogTitle = '题目错误分布'
      this.dialogVisible = true
    },
    handleExportDifficulty() {
      const dataURL = this.difficultyChart.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      })
      
      const link = document.createElement('a')
      link.download = '题目难度分布.png'
      link.href = dataURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleExportOriginalScoreDifficulty() {
      const dataURL = this.originalScoreDifficultyChart.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      })
      
      const link = document.createElement('a')
      link.download = '原始分与难度关系.png'
      link.href = dataURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleExportFixedScoreDifficulty() {
      const dataURL = this.fixedScoreDifficultyChart.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      })
      
      const link = document.createElement('a')
      link.download = '订正分与难度关系.png'
      link.href = dataURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleExportTagCloud() {
      const dataURL = this.tagCloudChart.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      })
      
      const link = document.createElement('a')
      link.download = '标签热度图.png'
      link.href = dataURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleExportScoreTag() {
      const dataURL = this.scoreTagChart.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      })
      
      const link = document.createElement('a')
      link.download = '标签分布图.png'
      link.href = dataURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleExportFullscreen() {
      if (!this.fullscreenChart) return
      
      try {
        const dataURL = this.fullscreenChart.getDataURL({
          type: 'png',
          pixelRatio: 2,
          backgroundColor: '#fff'
        })
        
        const link = document.createElement('a')
        link.download = `${this.dialogTitle}.png`
        link.href = dataURL
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        console.error('导出图片失败:', error)
        this.$message.error('导出图片失败')
      }
    },
    handleDialogOpen() {
      if (this.isInitializing) return
      this.isInitializing = true

      this.$nextTick(() => {
        try {
          const chartDom = this.$refs.fullscreenChart
          if (!chartDom || !this.currentChartType) return

          this.fullscreenChart = echarts.init(chartDom)
          let option = null

          switch (this.currentChartType) {
            case 'errorType':
              option = this.errorTypeChart.getOption()
              if (option && option.series && option.series[0]) {
                option.series[0].radius = ['35%', '55%']
                option.series[0].center = ['50%', '50%']
              }
              if (option && option.legend) {
                option.legend.left = '5%'
              }
              break
            case 'difficulty':
              option = this.difficultyChart.getOption()
              option.series[0].radius = ['35%', '55%']
              option.series[0].center = ['50%', '50%']
              option.legend.left = '5%'
              break
            case 'originalScoreDifficulty':
              option = this.originalScoreDifficultyChart.getOption()
              option.grid = {
                left: '0%',
                right: '0%',
                bottom: '10%',
                top: '10%',
                containLabel: true
              }
              break
            case 'fixedScoreDifficulty':
              option = this.fixedScoreDifficultyChart.getOption()
              option.grid = {
                left: '0%',
                right: '0%',
                bottom: '10%',
                top: '10%',
                containLabel: true
              }
              break
            case 'tagCloud':
              option = this.tagCloudChart.getOption()
              option.series[0] = {
                ...option.series[0],
                width: '100%',
                height: '100%',
                sizeRange: [15, 48],
                rotationRange: [-90, 90],
                gridSize: 10,
                layoutAnimation: true
              }
              break
            case 'scoreTag':
              option = this.scoreTagChart.getOption()
              option.grid = {
                left: '2%',
                right: '2%',
                bottom: '10%',
                top: '10%',
                containLabel: true
              }
              // 确保全屏模式下使用相同的难度刻度设置
              if (option.yAxis && option.yAxis.length > 1) {
                option.yAxis[1].interval = 14.29; // 100/7，确保显示所有8个难度等级
                option.yAxis[1].axisLabel = {
                  formatter: (value) => {
                    // 精确匹配每个刻度值对应的难度等级
                    const step = 100 / 7; // 7个间隔对应8个难度等级
                    // 使用Math.round确保浮点数比较的准确性
                    const roundedValue = Math.round(value * 100) / 100;
                    
                    for (let i = 0; i < this.difficultyOrder.length; i++) {
                      const expectedValue = Math.round(i * step * 100) / 100;
                      if (Math.abs(roundedValue - expectedValue) < 0.01) {
                        return this.difficultyOrder[i];
                      }
                    }
                    return '';
                  }
                };
              }
              break
          }

          if (option) {
            this.fullscreenChart.setOption(option)
            this.resizeHandler = _.debounce(() => {
              if (this.fullscreenChart) {
                this.fullscreenChart.resize()
              }
            }, 100)
            window.addEventListener('resize', this.resizeHandler)
          }
        } catch (error) {
          console.error('初始化全屏图表失败:', error)
          this.$message.error('初始化图表失败')
        } finally {
          this.isInitializing = false
        }
      })
    },
    handleDialogClose() {
      // 在关闭前清理
      this.cleanupFullscreen()
    },
    handleDialogClosed() {
      // 在完全关闭后重置状态
      this.currentChartType = ''
      this.isInitializing = false
    },
    cleanupFullscreen() {
      // 移除 resize 事件监听
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
        this.resizeHandler = null
      }

      // 销毁图表实例
      if (this.fullscreenChart) {
        this.fullscreenChart.dispose()
        this.fullscreenChart = null
      }
    },
    handleFullscreenDifficulty() {
      // 先清理旧的实例
      this.cleanupFullscreen()
      this.currentChartType = 'difficulty'
      this.dialogTitle = '题目难度分布'
      this.dialogVisible = true
    },
    handleFullscreenOriginalScoreDifficulty() {
      this.cleanupFullscreen()
      this.currentChartType = 'originalScoreDifficulty'
      this.dialogTitle = '原始分与难度关系'
      this.dialogVisible = true
    },
    handleFullscreenFixedScoreDifficulty() {
      this.cleanupFullscreen()
      this.currentChartType = 'fixedScoreDifficulty'
      this.dialogTitle = '订正分与难度关系'
      this.dialogVisible = true
    },
    handleFullscreenTagCloud() {
      this.cleanupFullscreen()
      this.currentChartType = 'tagCloud'
      this.dialogTitle = '标签热度图'
      this.dialogVisible = true
    },
    handleFullscreenScoreTag() {
      this.cleanupFullscreen()
      this.currentChartType = 'scoreTag'
      this.dialogTitle = '标签分布图'
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    getScoreColor(score) {
      // 根据分数返回颜色
      if (score >= 90) return '#67C23A'  // 绿色
      if (score >= 80) return '#409EFF'  // 蓝色
      if (score >= 70) return '#E6A23C'  // 橙色
      return '#F56C6C'  // 红色
    },
    // 处理错误类型时间变化
    handleErrorTypeDateChange(val) {
      console.log('错误类型时间范围变化:', val)
      this.errorTypeDateRange = val
      this.fetchData()
    },
    // 重置错误类型时间筛选
    handleErrorTypeReset() {
      this.errorTypeDateRange = null
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.question-analysis {
  width: 100%;
}

.chart-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.chart-row:last-child {
  margin-bottom: 0;
}

.chart-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.one-third {
  flex: 0 0 calc(33.33% - 14px);  /* 1/3宽度，减去gap的一部分 */
}

.two-thirds {
  flex: 0 0 calc(66.67% - 6px);  /* 2/3宽度，减去gap的一部分 */
}

.half-width {
  flex: 0 0 calc(50% - 10px);  /* 1/2宽度，减去gap的一部分 */
}

.full-width {
  flex: 0 0 100%;
}

.chart-card :deep(.el-card__header) {
  padding: 0;
  border-bottom: none;
}

.chart-container {
  height: 400px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

/* 为标签分布图单独设置样式 */
.score-tag-chart .chart-container {
  height: 500px !important;
  padding: 10px !important;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 20px;
  height: 16px;
  box-sizing: content-box;
  background-color: #2E365A;
  color: #ffffff;
  border-radius: 8px 8px 0 0;
}

.operations {
  display: flex;
  gap: 12px;
  align-items: center;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.button-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.operations .el-button {
  color: #ffffff;
}

.operations .el-button:hover {
  color: #BD6C73;
}

.el-button [class^="el-icon-"] {
  font-size: 16px;
}

.chart-dialog :deep(.el-dialog__header) {
  padding: 0;
  margin: 0;
}

.chart-dialog :deep(.el-dialog__headerbtn) {
  display: none;
}

.chart-dialog :deep(.el-dialog__body) {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 20px;
  height: 16px;
  box-sizing: content-box;
  background-color: #2E365A;
  color: #ffffff;
  border-bottom: none;
}

.dialog-operations {
  display: flex;
  gap: 8px;
}

.dialog-operations .el-button {
  color: #ffffff;
}

.dialog-operations .el-button:hover {
  color: #BD6C73;
}

.fullscreen-chart {
  width: 100%;
  height: 600px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-card[ref="scoreTagCard"] .chart-container {
  height: 500px;
}

/* 使用新的 class 选择器 */
.score-tag-chart .chart-container {
  height: 500px !important;
}

/* 日期选择器样式 */
.filter-item :deep(.el-date-editor.el-input),
.filter-item :deep(.el-date-editor.el-range-editor) {
  width: 260px !important;
  height: 28px !important;
  line-height: 28px !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  border: none !important;
  border-radius: 4px !important;
}

.filter-item :deep(.el-date-editor.el-range-editor:hover) {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.filter-item :deep(.el-range-input) {
  background-color: transparent !important;
  color: #fff !important;
  font-size: 12px !important;
  height: 100% !important;
  margin: 0 !important;
  vertical-align: middle !important;
  width: 90px !important;
  padding: 0 2px !important;
}

.filter-item :deep(.el-range-separator) {
  color: #fff !important;
  padding: 0 3px !important;
  line-height: 22px !important;
}

.filter-item :deep(.el-range__icon),
.filter-item :deep(.el-range__close-icon),
.filter-item :deep(.el-input__icon) {
  color: #fff !important;
  line-height: 28px !important;
  font-size: 14px !important;
  margin-top: -1px !important;
}

.filter-item :deep(.el-date-editor.el-range-editor) {
  padding: 0 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

/* 对象样式覆盖以解决外部容器问题 */
.filter-item :deep(.el-range-editor.el-input__inner) {
  height: 28px !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border: none !important;
}

/* 解决输入框可能的显示问题 */
.filter-item :deep(.el-range-editor .el-range-input::-webkit-input-placeholder) {
  color: rgba(255, 255, 255, 0.7) !important;
}
.filter-item :deep(.el-range-editor .el-range-input::-moz-placeholder) {
  color: rgba(255, 255, 255, 0.7) !important;
}
.filter-item :deep(.el-range-editor .el-range-input:-ms-input-placeholder) {
  color: rgba(255, 255, 255, 0.7) !important;
}
</style> 